import { useContext } from 'react';
import ActionItem from './ActionItem.jsx';

/**
 * Retrieves ActionItemContext
 * @return {object} context value or props value
 */
export default function useActionItemContext(props) {
  const context = useContext(ActionItem.Context || {});
  let clicked = props.clicked,
    onClose = props.onClose;

  if (context) {
    clicked = context.clicked;
    onClose = context.onClose;
  }

  return { clicked, onClose };
}
